import AsyncStorage from "@react-native-async-storage/async-storage";
import { isWeb, sendMessageToFrame } from "../utils/Helper";
import { NativeModules } from "react-native";
import { ASSAABLOY, ISINROOMTAB, SALTO } from "../config/Constant";
import { makeLayoutApiCalls } from "./fetchAppConfigs";
import { setRenderFlashMessage, setRenderLoader } from "../Redux/Actions/appConfigAction";
const { AssaAbloyPlugin, SaltoPlugin } = NativeModules;
import { setOverlayVisible } from "../Redux/Reducers/appConfigReducer";

export const clearDoorKey = async (door_key_type) => {
  try {

    return new Promise((resolve) => {
      // This is to clear the door key stored for door key feature.

      if (!isWeb() && door_key_type === ASSAABLOY && AssaAbloyPlugin) {
        AssaAbloyPlugin.terminateEndpoint();
      }


      console.log("wipeguestData", door_key_type, SaltoPlugin);
      
      if (!isWeb() && door_key_type === SALTO && SaltoPlugin) {
        SaltoPlugin.terminateEndpoint();
      }

      resolve();
    });
  } catch (e) {
    console.error("Error in clearDoorKey:", e);
    return Promise.resolve();
  }
};

export const wipeGuestData = ({ innspireChatRef }) => {


  return async (dispatch, getState) => {
    try {

      dispatch(setOverlayVisible(true));


      const { isLoggedIn, doorKeyType } = getState().appConfigSlice;

      const allKeys = await AsyncStorage.getAllKeys();

      const protectedKeys = [
        "corporateSessionToken",
        "cachedDeviceConfigs",
        "fcmToken",
        "X_BOOKING_DATA_HOTEL_SPECIFIC_LIST",
        "X_CHECKIN_PQ_DATA_HOTEL_SPECIFIC_LIST",

        "connectorIP_inroomapp",
        "clientId_inroomapp",
      ];

      if (allKeys && Array.isArray(allKeys)) {

        const keysToDelete = allKeys.filter((key) => {
          if (protectedKeys.includes(key)) return false;
          if (ISINROOMTAB && key === "roomID") return false;
          if (ISINROOMTAB && key === "deviceName") return false;
          return true;
        });
        
        if (keysToDelete.length > 0) {
          await AsyncStorage.multiRemove(keysToDelete);
        }
      }

      // remove InnSpireChatBot
      AsyncStorage.removeItem("innSpireChatLoginInit");
      if (innspireChatRef.current) {
        sendMessageToFrame(innspireChatRef, { type: "INNSPIRECHAT_LOGOUT" })
      }

      if(isLoggedIn) await clearDoorKey(doorKeyType);


      setTimeout(() => {
        dispatch(makeLayoutApiCalls());
      }, 1000);
    } catch (error) {
      dispatch(setOverlayVisible(false));
      console.log("Error calling wipeGuestData:", error);
      dispatch(setRenderFlashMessage(true, { type: "danger", message: "Something went wrong" }));
    }
  }
};
